module.exports = __webpack_public_path__ + "static/media/03_05.dc5d8518.png";